import { lazy } from "react";
import i18n from "i18next";
import type { DuelModule } from "../types";
import { CHESS_DUEL_NS, registerChessDuelTranslations } from "./i18n";

registerChessDuelTranslations(i18n);

/** Chess between colleagues (ADR 0076). The rules live in `src/lib/chess`. */
export const chessModule: DuelModule = {
  key: "chess",
  namespace: CHESS_DUEL_NS,
  Board: lazy(() => import("./Board")),
};
